export default "__VITE_ASSET__5763c1a3__"